import {
    DashboardLayout,
    DashboardSidebarPageItem,
    NavigationPageItem,
} from '@toolpad/core';
import { IKContext } from 'imagekitio-react';
import React from 'react';
import { Outlet } from 'react-router';

import { ProtectedRoute } from '@barboxx/admin-components';
import {
    BusinessSelectorProvider,
    SearchStringProvider,
    useAuth,
    useBusinessSelector,
} from '@barboxx/admin-utils';
import Api from '@barboxx/api';
import { UserTypes } from '@barboxx/types';

import {
    REACT_APP_IMAGE_KIT_PUBLIC_KEY,
    REACT_APP_IMAGE_KIT_URL_ENDPOINT,
} from '../environments/environment';

export type CustomNavigationPageItem = NavigationPageItem & {
    userTypes?: UserTypes[];
};

export default function Layout() {
    return (
        <ProtectedRoute allowedRoles={['Business', 'Internal']}>
            <BusinessSelectorProvider>
                <SearchStringProvider>
                    <InnerDashboardLayout />
                </SearchStringProvider>
            </BusinessSelectorProvider>
        </ProtectedRoute>
    );
}

function InnerDashboardLayout() {
    const { auth } = useAuth();
    const { BusinessSelectorComponent } = useBusinessSelector();
    const renderPageItem = React.useCallback(
        (item: CustomNavigationPageItem, { mini }: { mini: boolean }) => {
            if (item.userTypes?.length) {
                // Check if the user has permission to view this item
                const enableRoute = item.userTypes.includes(
                    auth?.user?.userType
                );
                if (!enableRoute) {
                    return null;
                }
            }
            if (item.title === 'BusinessSelector') {
                return <BusinessSelectorComponent />;
            }

            return (
                <DashboardSidebarPageItem
                    item={item}
                    // mini={mini}
                />
            );
        },
        [BusinessSelectorComponent, auth?.user?.userType]
    );

    return (
        <IKContext
            publicKey={REACT_APP_IMAGE_KIT_PUBLIC_KEY}
            urlEndpoint={REACT_APP_IMAGE_KIT_URL_ENDPOINT}
            transformationPosition="path"
            authenticator={Api.Images.getImageKitToken}
        >
            <DashboardLayout renderPageItem={renderPageItem}>
                <Outlet />
            </DashboardLayout>
        </IKContext>
    );
}
